export const siteConfig = {
  name: "Mobilink",
  sponsorName: "RV Vertex Technologies Private Limited",
  tagline: "Connect. Support. Solve.",
  description:
    "Mobilink is a secure mobile remote access platform that connects the Master Application to the User Application after permission is granted, enabling real-time screen viewing and remote device control.", url: "https://mobilink.tech",
  email: "support@mobilink.tech",
  phone: "+91 9177767772",
  address: "Third Floor, Plot No. 1202 & 1215A, Road No. 36, Shaikpet, Jubilee Hills, Hyderabad, Telangana 500033",
};

export const navLinks = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Features", href: "/features" },
  { label: "Solutions", href: "/solutions" },
  { label: "Industries", href: "/industries" },
  { label: "Pricing", href: "/pricing" },
  { label: "Blog", href: "/blog" },
];

export const footerLinks = {
  product: [
    { label: "Features", href: "/features" },
    { label: "Solutions", href: "/solutions" },
    { label: "Security", href: "/security" },
    { label: "Pricing", href: "/pricing" },
  ],
  company: [
    { label: "About", href: "/about" },
    { label: "Industries", href: "/industries" },
    { label: "Blog", href: "/blog" },
    { label: "Contact", href: "/contact" },
  ],
  resources: [
    { label: "FAQ", href: "/faq" },
    { label: "Privacy Policy", href: "/privacy-policy" },
    { label: "Terms & Conditions", href: "/terms" },
  ],
};

export const whyMobilink = [
  {
    title: "User Permission",
    description:
      "The User Application requires the user to grant permission before the Master Application can connect to the device.",
    icon: "ShieldCheck",
  },
  {
    title: "Master to User Connection",
    description:
      "Once permission is granted, the Master Application can establish a connection with the User Application.",
    icon: "Zap",
  },
  {
    title: "Real-Time Screen Viewing",
    description:
      "The Master can view the User's device screen in real time through the connected session.",
    icon: "Smile",
  },
  {
    title: "Remote Device Control",
    description:
      "With the required permission, the Master can remotely interact with and control the User's device.",
       icon: "Hand",
  },
  {
    title: "Permission-Based Access",
    description:
      "Device access and remote control are available only after the User grants the required permission.",
    icon: "Smartphone",
  },
  {
    title: "Connected Experience",
    description:
      "Viewing and remote control work together through a single connection between the Master and User Applications.",
    icon: "Building2",
  },
];

export const productFeatures = [
  {
    title: "Real-Time Screen Viewing",
    description:
      "The Master can view the User's device screen in real time after the User grants permission.",
    icon: "ScreenShare",
  },
  {
    title: "Unique User Code Pairing",
    description:
      "Each session uses a unique User Code to connect the User Application with the Master Application.",
    icon: "KeyRound",
  },
  {
    title: "Permission-Based Access",
    description:
      "The User must grant permission before the Master can connect, view the device screen, or use remote control capabilities.",
    icon: "ShieldCheck",
  },
  {
    title: "Secure, Encrypted Connections",
    description:
      "The connection between the User Application and Master Application is protected to help keep session communication secure.",
    icon: "Lock",
  },
  {
    title: "Remote Touch Control",
    description:
      "After the required permission is granted, the Master can remotely interact with the User's device to assist with actions on the screen.",
    icon: "Hand",
  },
  {
    title: "WebRTC streaming core",
    description:
      "Built on WebRTC to provide real-time communication between the Master Application and User Application for responsive screen viewing and remote interaction.",
    icon: "Radio",
  },
  {
    title: "Low latency, high clarity",
    description:
      "Optimized real-time streaming keeps the User device screen clear and responsive, helping the Master view and interact with the device with minimal delay.",
    icon: "Gauge",
  },
  {
    title: "Fast pairing",
    description:
      "The Master enters the User Code to initiate a connection, and the User grants permission before the Master can view and control the device.",
    icon: "Timer",
  },
  {
    title: "Session management",
    description:
      "Manage active Master-to-User connections, session duration, and session activity through the centralized Super Admin dashboard.",
    icon: "LayoutDashboard",
  },
  {
    title: "Easy setup",
    description:
      "The User installs and opens the User Application while the Master uses the Master Application to connect through a simple permission-based process.",
    icon: "Rocket",
  },
  {
    title: "Cross-platform by default",
    description:
      "The User Application supports mobile devices across iOS and Android, while the Master Application provides a connected interface for viewing and remote control.",
    icon: "Layers",
  },
  {
    title: "Enterprise ready",
    description:
      "Centralized administration, role-based access, session records, and management controls help organizations manage Master-to-User connections at scale.",
    icon: "Building2",
  },
  {
    title: "Lightweight footprint",
    description:
      "Designed to provide a simple and efficient User Application experience while enabling the Master to connect, view, and remotely control the User device after permission is granted.",
    icon: "Feather",
  },
];

export const howItWorks = [
  {
    step: "01",
    title: "Open the User App",
    description:
      "The User opens the Mobilink User Application on the device that will be connected to the Master.",
  },
  {
    step: "02",
    title: "Generate a User Code",
    description:
      "The User Application generates a unique code that identifies the User device and connection session.",
  },
  {
    step: "03",
    title: "Enter the Code in the Master App",
    description:
      "The Master opens the Master Application and enters the User Code to request a connection with the User device.",
  },
  {
    step: "04",
    title: "User Grants Permission",
    description:
      "The User receives a permission request and grants access before the Master can connect to the device.",
  },
  {
    step: "05",
    title: "Master Views & Controls",
    description:
      "Once connected, the Master can view the User's device screen in real time and remotely control the device according to the granted permissions.",
  },
];

export const industries = [
  {
    name: "Telecom",
    icon: "Signal",
    description:
      "Connect to User devices with permission to view network, SIM, and device settings and remotely assist when required.",
  },

  {
    name: "Healthcare",
    icon: "HeartPulse",
    description:
      "Allow the Master to view and remotely assist with healthcare applications and device-related tasks after User permission.",
  },

  {
    name: "Banking",
    icon: "Landmark",
    description:
      "Connect to User devices with permission to view banking applications and remotely assist with on-screen tasks.",
  },

  {
    name: "Insurance",
    icon: "FileCheck2",
    description:
      "View User screens and remotely assist with insurance applications, forms, and digital processes after permission is granted.",
  },

  {
    name: "Education",
    icon: "GraduationCap",
    description:
      "Connect the Master to User devices to view and remotely assist with learning platforms, applications, and device issues.",
  },

  {
    name: "Government",
    icon: "Landmark",
    description:
      "Enable permission-based access to User devices for viewing and remotely assisting with government digital services.",
  },

  {
    name: "Retail",
    icon: "ShoppingBag",
    description:
      "View and remotely assist with POS applications, loyalty tools, and device-related tasks through a permission-based connection.",
  },

  {
    name: "Customer Support",
    icon: "Headset",
    description:
      "Connect the Master to the User device to view the exact issue and remotely assist with on-screen actions after permission.",
  },

  {
    name: "IT Helpdesk",
    icon: "Wrench",
    description:
      "View User device screens and remotely assist with application, configuration, and device issues after permission is granted.",
  },

  {
    name: "Enterprise",
    icon: "Building2",
    description:
      "Enable permission-based Master-to-User connections for remote device viewing and control across teams and departments.",
  },
];

export const securityPoints = [
  {
    title: "Encrypted sessions",
    description: "Every screen-sharing session is encrypted in transit from the User App to the Master App.",
    icon: "Lock",
  },
  {
    title: "Permission Required",
    description: "The Master cannot access the User device until the User explicitly grants the required permission.",
    icon: "ShieldCheck",
  },
  {
    title: "Private, One-to-One Connections",
    description: "Each session connects a User Application with a Master Application through a dedicated connection.",
    icon: "Users",
  },
  {
    title: "Secure pairing codes",
    description: "User Codes are single-use and expire quickly, so old codes can't be reused to reconnect.",
    icon: "KeyRound",
  },
  {
    title: "Permission-Based Control",
    description: "Remote device control is available only after the User grants the required permission to the Master.",
    icon: "ShieldCheck",
  },
];

export const stats = [
  { value: 100, suffix: "+", label: "Enterprise clients" },
  { value: 99.9, suffix: "%", label: "Platform availability", decimals: 1 },
  { value: 50, suffix: "K+", label: "Support sessions run" },
  { value: 25, suffix: "+", label: "Countries served" },
];

export const testimonials = [
  {
    name: "Ananya Reddy",
    rating: 5,
    quote:
      "Mobilink makes the connection between the Master and User applications simple. Once the User grants permission, the Master can view the device screen and remotely assist without the usual back-and-forth.",
  },
  {
    name: "Rahul Sharma",
    rating: 5,
    quote:
      "The permission-first approach gives the User control over when access is granted. After permission, the Master can connect, view the device, and perform remote actions when required.",
  },
  {
    name: "Sneha Iyer",
    rating: 5,
    quote:
      "The Master can see exactly what is happening on the User device instead of relying on descriptions. Remote control also makes it easier to guide users through applications and device-related tasks.",
  },
  {
    name: "Vikram Rao",
    rating: 5,
    quote:
      "The User Code makes pairing straightforward, and once permission is granted, the Master can quickly connect to view and remotely control the User device.",
  },
];

export const pricingPlans = [
  {
    name: "Starter",
    price: "$29",
    period: "/agent / month",
    description: "For small support teams getting started with live screen sharing.",
    features: [
      "Up to 5 support agents",
      "Unlimited sessions",
      "iOS & Android User App",
      "Basic session history",
      "Email support",
    ],
    cta: "Start free trial",
    highlighted: false,
  },
  {
    name: "Business",
    price: "$59",
    period: "/agent / month",
    description: "For growing support organizations that need visibility and control.",
    features: [
      "Up to 50 support agents",
      "Unlimited sessions",
      "Team session dashboard",
      "Role-based access",
      "Priority support",
      "Session analytics",
    ],
    cta: "Book a demo",
    highlighted: true,
  },
  {
    name: "Enterprise",
    price: "Custom",
    period: "",
    description: "For large teams with compliance, scale, and integration needs.",
    features: [
      "Unlimited agents",
      "SSO & advanced permissions",
      "Dedicated infrastructure",
      "Custom SLAs",
      "Audit logs & compliance reports",
      "Dedicated account manager",
    ],
    cta: "Contact sales",
    highlighted: false,
  },
];

export const faqs = [
  {
    question: "Can the Master control the User's device?",
    answer:
      "Yes. After the User grants the required permission, the Master can view the User's device screen and remotely control the device according to the permissions granted.",
  },
  {
    question: "What is a User Code?",
    answer:
      "The User shares the User Code with the Master, who enters it in the Master Application to request a connection with the User device."
  },
  {
    question: "Does the customer need to create an account?",
    answer:
      "No. The customer only needs to install the free User App. There's no sign-up, no password, and nothing left installed with lasting access after the session ends.",
  },
  {
    question: "Is the connection encrypted?",
    answer:
      "Yes. Every session between the User App and the Master App runs over an encrypted connection, and each User Code expires shortly after it's issued.",
  },
  {
    question: "Which platforms does Mobilink support?",
    answer:
      "Mobilink provides the User Application for the User device and the Master Application for connecting to and managing User sessions."
  },
  {
    question: "Can I try Mobilink before committing?",
    answer:
      "Yes. Every plan starts with a free trial, and our team is happy to walk your organization through a live demo tailored to your industry.",
  },
];

export const blogPosts = [
  {
    slug: "reduce-resolution-time-with-remote-device-access",
    title: "How Real-Time Viewing and Remote Control Reduce Resolution Time",
    excerpt:
      "See how connecting the Master Application to the User Application helps identify device issues faster and enables remote assistance after permission is granted.",
    category: "Remote Access",
    date: "2026-06-12",
    readTime: "6 min read",
    body: [
      "Many device-related issues take longer to resolve because the Master has to understand what is happening on the User device through verbal descriptions. Menu names, settings, error messages, and application screens can be difficult to explain accurately.",
      "Mobilink simplifies this process by connecting the Master Application with the User Application after the User grants permission. The Master can then view the User device screen in real time and understand the issue directly from the connected session.",
      "When remote control is permitted, the Master can also interact with the User device to help complete the required steps. This reduces unnecessary back-and-forth and makes it easier to verify that the required action has been completed correctly.",
      "The improvement comes from a combination of real-time visibility, permission-based access, and remote interaction. The User remains responsible for granting access and can end the connection when the session is no longer required.",
    ],
  },

  {
    slug: "permission-first-remote-access-explained",
    title: "Why Permission-First Design Matters for Remote Device Access",
    excerpt:
      "Remote device access requires clear permission and transparency. Learn how Mobilink puts the User in control before the Master can connect.",
    category: "Security",
    date: "2026-05-28",
    readTime: "5 min read",
    body: [
      "Remote access involves more than establishing a technical connection. The User should understand when another application is requesting access to the device and what capabilities will be available during the session.",
      "Mobilink follows a permission-based connection model. The User Application requests the required permission, and the Master Application can connect only after the User grants that permission.",
      "Once connected, the Master can view the User device screen in real time and use remote control capabilities according to the permissions provided by the User. This creates a clear connection flow instead of allowing access without the User's involvement.",
      "A transparent permission experience also helps organizations establish clear access policies. Users can understand when a session starts, what access has been granted, and when they want to end the connection.",
    ],
  },

  {
    slug: "telecom-device-assistance-without-truck-rolls",
    title: "Telecom Device Assistance Without the Truck Roll",
    excerpt:
      "From SIM errors to APN settings, many telecom device issues can be identified and remotely assisted through a permission-based Master-to-User connection.",
    category: "Telecom",
    date: "2026-05-09",
    readTime: "4 min read",
    body: [
      "Many telecom device issues are related to settings, applications, connectivity, or configuration rather than hardware. Identifying the exact setting can be difficult when the User has to describe every screen and option over a call.",
      "Mobilink allows the User to open the User Application and provide permission before the Master Application connects. Once connected, the Master can view the User device screen and identify the relevant settings or application state.",
      "Where remote control is permitted, the Master can interact with the User device to assist with configuration and troubleshooting steps. This can reduce unnecessary device visits for issues that can be handled remotely.",
      "For telecom operations handling a large number of device-related requests, permission-based remote viewing and control can provide a more direct way to identify and resolve common configuration issues.",
    ],
  },

  {
    slug: "banking-remote-access-customers-can-understand",
    title: "Building Banking Remote Access Customers Can Understand",
    excerpt:
      "Banking environments require clear access controls. Here's what to consider when introducing permission-based remote device assistance.",
    category: "Banking",
    date: "2026-04-22",
    readTime: "7 min read",
    body: [
      "Banks evaluating remote device access need to understand exactly what the Master can see and what actions the Master can perform during a session. Clear permission controls are an important part of that decision.",
      "Mobilink uses a permission-first connection flow. The User Application requests permission before the Master Application can connect to the User device. After permission is granted, the Master can view the User screen and use remote control capabilities where those permissions are available.",
      "The User remains part of the connection process rather than having access established silently. This makes the start of a remote session visible and gives the User an opportunity to grant or decline the requested access.",
      "Organizations can combine this permission-based workflow with appropriate administrative controls, role-based access, and session records to establish policies around who can initiate and manage Master-to-User connections.",
    ],
  },

  {
    slug: "connecting-user-and-master-applications",
    title: "Connecting the User and Master Applications in Seconds",
    excerpt:
      "A walkthrough of the Mobilink connection flow, from generating a User Code to granting permission and starting a remote session.",
    category: "Product",
    date: "2026-04-03",
    readTime: "5 min read",
    body: [
      "The connection process is designed around two applications: the User Application running on the User device and the Master Application used to establish and manage the connection.",
      "The User opens the User Application and generates a unique User Code. The Master enters that code in the Master Application to initiate a connection request with the User device.",
      "Before the connection is established, the User receives the required permission request. The User can grant the permission so the Master can connect to the device.",
      "After permission is granted, the Master can view the User device screen in real time. Where remote control is permitted, the Master can also interact with the device to assist with the required task.",
    ],
  },

  {
    slug: "healthcare-remote-device-access-privacy",
    title: "Remote Device Access in Healthcare: Privacy Without Friction",
    excerpt:
      "Help Users navigate healthcare applications and device-related tasks while keeping permission and access controls at the center of every session.",
    category: "Healthcare",
    date: "2026-03-18",
    readTime: "6 min read",
    body: [
      "Healthcare applications and connected devices can be difficult for Users to configure or navigate without assistance. At the same time, device access requires clear boundaries around who can connect and when.",
      "Mobilink uses a permission-based workflow in which the User Application requests access before the Master Application can connect. The User can grant permission before the Master begins viewing the device.",
      "Once connected, the Master can view the User device screen in real time and, where remote control is permitted, interact with the device to assist with application navigation or device-related tasks.",
      "For healthcare organizations, the remote session should be configured according to their access, privacy, and administrative requirements. The permission-based connection gives the User a clear role in starting and ending the remote session.",
    ],
  },
];
export const trustedByLogos = [
  "NovaTel", "Harborline Bank", "Meridian Health", "Atlas Retail",
  "CivicLink", "Summit Insurance", "Brightpath Edu", "Vantage Telecom",
];

